var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9941 8.62964H9.99414C9.46371 8.62964 8.955 8.84035 8.57993 9.21543C8.20485 9.5905 7.99414 10.0992 7.99414 10.6296V18.6296C7.99414 19.1601 8.20485 19.6688 8.57993 20.0439C8.955 20.4189 9.46371 20.6296 9.99414 20.6296H17.9941C18.5246 20.6296 19.0333 20.4189 19.4084 20.0439C19.7834 19.6688 19.9941 19.1601 19.9941 18.6296V10.6296C19.9941 10.0992 19.7834 9.5905 19.4084 9.21543C19.0333 8.84035 18.5246 8.62964 17.9941 8.62964Z",
    stroke: "#FEFEFE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9941 8.62964V6.62964C15.9941 6.09921 15.7834 5.5905 15.4084 5.21543C15.0333 4.84035 14.5246 4.62964 13.9941 4.62964H5.99414C5.46371 4.62964 4.955 4.84035 4.57993 5.21543C4.20485 5.5905 3.99414 6.09921 3.99414 6.62964V14.6296C3.99414 15.1601 4.20485 15.6688 4.57993 16.0439C4.955 16.4189 5.46371 16.6296 5.99414 16.6296H7.99414",
    stroke: "#FEFEFE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.71731e061969c46b7427126a21ba31f6.svg";
export { ForwardRef as ReactComponent };